import * as z from "zod";

import { surrealRecordSchema } from "./surreal-record";

export const maintenancePlanSchema = surrealRecordSchema.extend({
  description: z.string(),
  cost: z.number().optional(),
  yearlyFrequency: z.coerce.number().optional(),
  createdAt: z.coerce.date(),
});

export type MaintenancePlan = z.infer<typeof maintenancePlanSchema>;
